exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ":host{display:inline-block;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-size:medium}app-balloon /deep/ .content{font-size:12px}app-balloon /deep/ .fa{color:#8fb5cf}", "", {"version":3,"sources":["/srv/projects/jsapp/src/app/shared/hint/hint.component.css"],"names":[],"mappings":"AAAA,MACE,qBAAsB,eACN,yBAChB,sBAAA,qBAAA,iBAAkB,gBACC,CACpB,4BAGC,cAAgB,CACjB,uBAGA,aAAe,CACf","file":"hint.component.css","sourcesContent":[":host{\n  display: inline-block;\n  cursor: pointer;\n  user-select: none;\n  font-size: initial;\n}\n\napp-balloon /deep/ .content{\n  font-size: 12px;\n}\n\napp-balloon /deep/ .fa {\n color: #8FB5CF;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/hint/hint.component.css
// module id = G8nr
// module chunks = 6